var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnOnboardingPhotographerOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_onboarding_photographer_off"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.8349 27.723C28.6605 27.723 25.978 30.4055 25.978 33.5799C25.978 36.7544 28.6605 39.4369 31.8349 39.4369C35.0094 39.4369 37.6919 36.7544 37.6919 33.5799C37.6919 30.4055 35.0094 27.723 31.8349 27.723Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M47.4523 19.9136H43.4661C42.7858 19.9136 42.1334 19.6433 41.6524 19.1623L37.1187 14.6287C36.7527 14.2625 36.2562 14.0568 35.7385 14.0566H27.9292C27.4115 14.0568 26.915 14.2625 26.549 14.6287L22.0153 19.1623C21.5343 19.6433 20.8819 19.9136 20.2016 19.9136H16.2154C14.062 19.9136 12.3108 21.6648 12.3108 23.8182V45.2935C12.3108 47.4469 14.062 49.1981 16.2154 49.1981H47.4523C49.6057 49.1981 51.3569 47.4469 51.3569 45.2935V23.8182C51.3569 21.6648 49.6057 19.9136 47.4523 19.9136ZM31.8338 43.3412C26.5431 43.3412 22.0723 38.8704 22.0723 33.5797C22.0723 28.2889 26.5431 23.8182 31.8338 23.8182C37.1246 23.8182 41.5954 28.2889 41.5954 33.5797C41.5954 38.8704 37.1246 43.3412 31.8338 43.3412Z",
    fill: "#999999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnOnboardingPhotographerOff);
export default __webpack_public_path__ + "static/media/icn_onboarding_photographer_off.2f132d47c3014af92d91f9e667ea34f7.svg";
export { ForwardRef as ReactComponent };